import React, { FunctionComponent, useCallback, useRef, useState, useEffect, ReactNode } from 'react';
import Tooltip from '../tooltip';
import * as Styled from './styled';

interface TruncatedTooltipProps {
  children: ReactNode;
}

export const TruncatedTooltip: FunctionComponent<TruncatedTooltipProps> = ({ children }) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = useCallback(() => {
    if (textRef.current) {
      const { scrollWidth, offsetWidth } = textRef.current;
      setIsTruncated(scrollWidth > offsetWidth);
    }
  }, []);

  useEffect(() => {
    checkTruncation();
    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [checkTruncation]);

  return (
    <Tooltip content={isTruncated ? children : null} hasTruncation>
      <Styled.TruncatedText ref={textRef} onMouseEnter={checkTruncation}>
        {children}
      </Styled.TruncatedText>
    </Tooltip>
  );
};
